import { getLoginConfigs } from './services/auth';

const GetImgBrandNameandMfaCheck = async () => {
  try {
    const response = await getLoginConfigs();
    const data = response?.data?.data;

    if (data) {
      localStorage.setItem('logo', JSON.stringify(data));
    }

    if (data?.name) {
      document.title = data.name;
    }
    if (data?.faviconUrl) {
      setFavicon(data.faviconUrl);
    }
  } catch (error) {
    console.error('Error fetching API:', error);
    document.title = 'App';
  }
};

const setFavicon = (faviconUrl) => {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon'; // Ensure correct type
    document.head.appendChild(link);
  }
  link.href = faviconUrl;
};

// Run function on page load
window.addEventListener('load', () => {
  GetImgBrandNameandMfaCheck();
});
